import { CircularProgress } from '@material-ui/core'

import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  align-self: center;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default (props: { loading: boolean; children: JSX.Element }) => {
  if (props.loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    )
  }

  return props.children || null
}
